import React from 'react';

import {
  signFromType
} from '../worksheets/lib/math';

export default class FlashcardProblem extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="flashcard-creator__problem flashcard">
        <span className="flashcard-creator__problem-top">{this.props.top}</span>
        <span className="flashcard-creator__problem-bottom">{this.props.bottom}</span>
        <span className="flashcard-creator__problem-sign">{signFromType(this.props.type)}</span>
        <span className="flashcard-creator__problem-line"></span>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/flashcard-creator/flashcard-problem.js
 **/